import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Check } from "lucide-react";
import { api } from "../lib/api";

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);
  const nav = useNavigate();

  const load = () => api.get("/notifications").then((r) => setNotifs(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  const open = async (n) => {
    await api.post(`/notifications/${n.id}/read`).catch(() => {});
    if (n.task_id) nav(`/tasks/${n.task_id}`);
    else load();
  };

  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl md:text-4xl font-heading font-black text-navy">Notifications</h1>
        <button onClick={markAll} className="text-sm font-bold text-navy hover:underline" data-testid="mark-all">Tout marquer lu</button>
      </div>

      {notifs.length === 0 ? (
        <div className="card-surface p-10 text-center text-[#475569]">Aucune notification.</div>
      ) : (
        <div className="space-y-2">
          {notifs.map((n) => (
            <button key={n.id} onClick={() => open(n)} data-testid={`notif-${n.id}`}
              className={`w-full card-surface p-4 flex items-start gap-3 text-left hover:bg-surface transition-colors ${n.read ? "opacity-70" : ""}`}>
              <div className={`h-10 w-10 rounded-full flex items-center justify-center shrink-0 ${n.read ? "bg-surface text-[#94A3B8]" : "bg-lime text-navy"}`}>
                {n.read ? <Check size={16} /> : <Bell size={16} />}
              </div>
              <div className="flex-1">
                <div className="font-bold text-navy">{n.title}</div>
                <div className="text-sm text-[#475569]">{n.content}</div>
                <div className="text-xs text-[#94A3B8] mt-1">{new Date(n.created_at).toLocaleString()}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
